<template>
  <main>
    <h3 class="d-none d-md-block">TRANSACCIONES ON-LINE</h3>
    <h3 class="d-md-none font-weight-bold">TRANSACCIONES <br />ON-LINE</h3>
    
    <!-- Descripción del módulo -->
    <div class="alert d-flex align-items-center mb-4" role="alert" style="background-color: #66C4DE; border-color: #66C4DE;">
      <i class="fas fa-info-circle fa-2x" style="margin-right: 15px; color: #fff;"></i>
      <div>
        <p class="mb-0" style="color: #353535;">
          <strong>Monitorea y gestiona todos los pagos automáticos procesados por CentralGym.</strong> 
          Este módulo te proporciona visibilidad completa sobre las transacciones de membresías realizadas 
          a través del sistema de pagos en línea, permitiéndote rastrear el estado de cada cobro, 
          identificar rápidamente pagos exitosos o fallidos, analizar tendencias de recaudación mensual, 
          y exportar información detallada para conciliación bancaria o análisis financiero avanzado.
        </p>
      </div>
    </div>
    
    <sales-table
      ref="salesTable"
      :branches.sync="branches"
      :statusCatalog.sync="statusDictionary"
      :trxTypeCatalog.sync="trxTypeDictionary"
      :records.sync="records"
      :loading="loading"
      :totalRecords="totalRecords"
      :totalFilteredRecords="totalFilteredRecords"
      :totalFilteredAmount="totalFilteredAmount"
      :totalPaidSales="totalPaidSales"
      :totalPendingSales="totalPendingSales"
      :totalErrorSales="totalErrorSales"
      :totalSuccessfulNotifications="totalSuccessfulNotifications"
      :allFilteredRecords="allFilteredRecords"
      :localPagination="localPagination"
      @search="handleSearch"
      @searchUnified="handleSearchUnified"
      @fetchNewPage="handleFetchNewPage"
      @export="handleExportRecords"
      @applyAdvancedFilters="applyAdvancedFiltersLocally"
      @clearAdvancedFilters="clearAdvancedFilters"
      @applyLocalDateFilter="applyLocalDateFilterOnData"
    ></sales-table>
  </main>
</template>

<script>
import SalesTable from "./OnLineSales/OnLineSalesTable.vue";
import XLSXpopulate from "xlsx-populate";
import excelExportMixin from '@/mixins/excelExportMixin';
export default {
  components: {
    SalesTable,
  },
  mixins: [excelExportMixin],
  data() {
    return {
      statusDictionary: [],
      trxTypeDictionary: [],
      records: [],
      branches: [],
      downloadedRecordsCount: 0,
      loading: false,
      
      // KPIs para props del componente hijo
      totalRecords: 0,
      totalFilteredRecords: 0,
      totalFilteredAmount: 0,
      totalPaidSales: 0,
      totalPendingSales: 0,
      totalErrorSales: 0,
      totalSuccessfulNotifications: 0,
      
      // NUEVO: Sistema de paginación local
      allFilteredRecords: [], // TODOS los registros filtrados (actuales, pueden incluir filtros avanzados)
      originalFilteredRecords: [], // Copia de los datos originales de la consulta básica (sin filtros avanzados)
      localPagination: {
        currentPage: 1,
        itemsPerPage: 20, // ACTUALIZADO: 20 registros por página
        totalPages: 1
      }
    };
  },
  methods: {
    async handleExportRecords(
      selectedStatus,
      selectedTrxType,
      selectedBranch,
      dateFrom,
      dateTo,
      commerceOrder
    ) {
      this.$swal.fire({
        title: "Cargando!!",
        text: `Un momento por favor...`,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data;
      let template;
      let Parameters = {};
      if (selectedStatus) Parameters.status = selectedStatus;

      if (selectedTrxType) Parameters.trxType = selectedTrxType;

      if (selectedBranch) Parameters.branch = selectedBranch;

      if (dateFrom) Parameters.dateFrom = dateFrom;

      if (dateTo) Parameters.dateTo = dateTo;

      if (typeof commerceOrder === "number")
        Parameters.sale = parseInt(commerceOrder);
      try {
        // OPTIMIZADO v3.0: Usar versión asíncrona para evitar timeouts
        // El método createOnlineSalesRecordsExportDataAsync viene del mixin
        data = await this.createOnlineSalesRecordsExportDataAsync(Parameters);
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Error!",
          text: `${
            error.message || error
          }. Vuelve a intentarlo mas tarde, si el problema persiste ponte en contacto con soporte.`,
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
        return;
      }
      this.$swal.update({
        title: "Generando...",
        text: "Descargando template XLSX",
      });
      this.$swal.showLoading();
      this.downloadedRecordsCount = 0;
      try {
        template = await this.fetchExcelTemplate(
          "RegistroVentasPasarelasDePago"
        );
      } catch (error) {
        this.$swal.fire({
          title: "Error!",
          text: `${
            error.message ||
            "Ha ocurrido un error durante la recuperación del template"
          }, Vuelve a intentarlo más tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: "#6bd098",
        });
        return;
      }

      if (!template || template.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              template.error ||
              "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return;
          });
      }
      this.$swal.update({
        title: "Generando...",
        text: "Generando reporte, un momento por favor",
      });
      this.$swal.showLoading();
      
      // OPTIMIZADO v3.0: Usar generación asíncrona de Excel con barra de progreso
      try {
        await this.generateExcelFileAsyncOnline(data, template);
      } catch (error) {
        this.$logger.error('Error generando Excel:', error);
        this.$swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message || "Ha ocurrido un error durante la generación del archivo Excel",
          confirmButtonColor: "#6bd098",
        });
      }
    },
    
    // Método personalizado para generar Excel de ventas online
    async generateExcelFileAsyncOnline(data, template) {
      this.$swal.fire({
        title: "Generando reporte Excel...",
        html: `
          <div class="text-center">
            <div class="mb-3">
              <i class="fas fa-file-excel fa-3x text-success mb-3"></i>
            </div>
            <div class="progress mb-3" style="height: 25px;">
              <div id="export-progress-bar" class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                   role="progressbar" style="width: 0%">
                0%
              </div>
            </div>
            <p class="text-muted small">
              <span id="export-status">Preparando datos...</span>
            </p>
          </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      try {
        await XLSXpopulate.fromDataAsync(template).then(async (wb) => {
          const sheet = wb.sheet(0);
          sheet.cell("D3").value(this.$moment().format("DD/MM/YYYY - HH:mm:ss"));
          
          const totalRows = data.length;
          const { AsyncDataProcessor } = await import('@/utils/asyncDataProcessor');
          let processedRows = 0;

          // Procesar datos en chunks para evitar bloqueos
          const processOptions = {
            chunkSize: 100,
            delay: 10, // Pequeña pausa entre chunks
            onProgress: (processed, total) => {
              const progress = Math.round((processed / total) * 100);
              this.$logger.log(`Progreso de exportación: ${progress}%`);
            }
          };
          
          await AsyncDataProcessor.processInChunks(
            data,
            (chunk) => {
              chunk.forEach((record) => {
                const row = processedRows + 7;
                
                // Columnas básicas
                sheet.cell(`C${row}`).value(record.commerceOrder);
                if (record.plataforma) sheet.cell(`D${row}`).value(record.plataforma);
                if (record.itemVendido?.valorPlan) sheet.cell(`E${row}`).value(record.itemVendido.valorPlan);
                if (record.responsable) sheet.cell(`F${row}`).value(record.responsable);
                
                // Fechas
                if (this.$moment(record.fechaCreacion).isValid()) {
                  sheet.cell(`G${row}`).value(this.$moment(record.fechaCreacion).format(`DD-MM-YYYY`));
                  sheet.cell(`H${row}`).value(this.$moment(record.fechaCreacion).format("HH:mm:ss"));
                }
                
                // Estados y tipo
                if (record.estado) sheet.cell(`I${row}`).value(record.estado);
                if (record.tipoVenta) sheet.cell(`J${row}`).value(record.tipoVenta);
                if (record.nombreSucursal) sheet.cell(`K${row}`).value(record.nombreSucursal);
                if (record.detalle) sheet.cell(`L${row}`).value(record.detalle);
                
                // Datos del socio
                if (record.socio) {
                  if (record.socio.rut) sheet.cell(`M${row}`).value(record.socio.rut);
                  if (record.socio.nombre) sheet.cell(`N${row}`).value(record.socio.nombre);
                  if (record.socio.email) sheet.cell(`O${row}`).value(record.socio.email);
                  if (record.socio.telefono) sheet.cell(`P${row}`).value(record.socio.telefono);
                }
                
                // Tipo de transacción
                if (record.tipoTransaccion) sheet.cell(`Q${row}`).value(record.tipoTransaccion);
                
                // Datos del ítem vendido
                if (record.itemVendido) {
                  const item = record.itemVendido;
                  
                  if (item.idPlanServicio) sheet.cell(`R${row}`).value(item.idPlanServicio);
                  if (item.glosaPlan) sheet.cell(`S${row}`).value(item.glosaPlan);
                  if (item.tipoItem) sheet.cell(`T${row}`).value(item.tipoItem);
                  if (item.glosaConvenio) sheet.cell(`U${row}`).value(item.glosaConvenio);
                  if (item.rutCliente) sheet.cell(`V${row}`).value(item.rutCliente);
                  if (item.razonSocialCliente) sheet.cell(`W${row}`).value(item.razonSocialCliente);
                  
                  // Fechas del plan
                  if (this.$moment(item.fechaInicioPlan).isValid()) {
                    sheet.cell(`X${row}`).value(this.$moment(item.fechaInicioPlan).format(`DD-MM-YYYY`));
                  }
                  if (this.$moment(item.fechaFinPlan).isValid()) {
                    sheet.cell(`Y${row}`).value(this.$moment(item.fechaFinPlan).format(`DD-MM-YYYY`));
                  }
                  
                  // Método de pago
                  if (item.metodoPago) sheet.cell(`Z${row}`).value(item.metodoPago);
                  
                  // Aplicación origen
                  if (record.aplicacionOrigen) sheet.cell(`AA${row}`).value(record.aplicacionOrigen);
                  
                  // Membresía activa
                  if (typeof item.membresiaActiva === "boolean") {
                    sheet.cell(`AB${row}`).value(item.membresiaActiva ? "SI" : "NO");
                  }
                  
                  // Más datos del plan
                  if (item.rutBeneficiario) sheet.cell(`AC${row}`).value(item.rutBeneficiario);
                  if (item.nombreBeneficiario) sheet.cell(`AD${row}`).value(item.nombreBeneficiario);
                  if (item.familiaPlan?.glosa) sheet.cell(`AE${row}`).value(item.familiaPlan.glosa);
                  if (item.categoriaPlan?.glosa) sheet.cell(`AF${row}`).value(item.categoriaPlan.glosa);
                  if (item.modalidadPlan?.glosa) sheet.cell(`AG${row}`).value(item.modalidadPlan.glosa);
                  if (item.recibeFactura) sheet.cell(`AH${row}`).value(item.recibeFactura);
                  if (typeof item.cobrarMatricula === "boolean") {
                    sheet.cell(`AI${row}`).value(item.cobrarMatricula ? "SI" : "NO");
                  }
                  if (typeof item.valorMatricula === "number") {
                    sheet.cell(`AJ${row}`).value(item.valorMatricula);
                  }
                  if (typeof item.duracionPlan === "number") {
                    sheet.cell(`AK${row}`).value(item.duracionPlan);
                  }
                  if (item.unidadDuracionPlan?.glosa) {
                    sheet.cell(`AL${row}`).value(item.unidadDuracionPlan.glosa);
                    sheet.cell(`AM${row}`).value(item.unidadDuracionPlan.glosa);
                  }
                  if (item.convenio?.glosa) {
                    sheet.cell(`AN${row}`).value(item.convenio.glosa);
                  }
                  if (typeof item.indicadorUsoSesiones === "boolean") {
                    sheet.cell(`AO${row}`).value(item.indicadorUsoSesiones ? "SI" : "NO");
                  }
                  if (typeof item.sesionesLimite === "number") {
                    sheet.cell(`AP${row}`).value(parseInt(item.sesionesLimite));
                  }
                  if (typeof item.sesionesUtilizadas === "number") {
                    sheet.cell(`AQ${row}`).value(parseInt(item.sesionesUtilizadas));
                  }
                  if (item.nombreSucursalAsignacion) {
                    sheet.cell(`AR${row}`).value(item.nombreSucursalAsignacion);
                  }
                  if (item.informacionAdicional) {
                    sheet.cell(`AS${row}`).value(item.informacionAdicional.multiSede === false ? "mono-sede" : "multi-sede");
                  } else {
                    sheet.cell(`AS${row}`).value("multi-sede");
                  }
                }
                
                processedRows++;
              });
              
              // Actualizar progreso
              const progress = Math.round((processedRows / totalRows) * 100);
              const progressBar = document.getElementById('export-progress-bar');
              const statusText = document.getElementById('export-status');
              
              if (progressBar) {
                progressBar.style.width = progress + '%';
                progressBar.textContent = progress + '%';
              }
              
              if (statusText) {
                statusText.textContent = `Procesando ${processedRows.toLocaleString()} de ${totalRows.toLocaleString()} registros...`;
              }
            },
            processOptions
          );

          // Generar el archivo Excel
          this.$swal.update({
            title: "Finalizando exportación...",
            html: `
              <div class="text-center">
                <i class="fas fa-file-excel fa-3x text-success mb-3"></i>
                <p>Generando archivo Excel...</p>
              </div>
            `
          });

          await wb.outputAsync().then((blob) => {
            const fileName = `Registro Transacciones On-line - ${this.$moment().format("DD-MM-yyyy - HH-mm-ss")}.xlsx`;
            
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              document.body.appendChild(a);
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            }
            
            this.$swal.fire({
              icon: 'success',
              title: '¡Exportación exitosa!',
              html: `
                <div>
                  <p>Se exportaron <strong>${totalRows.toLocaleString()}</strong> registros exitosamente.</p>
                  <p class="text-muted small">Archivo: ${fileName}</p>
                </div>
              `,
              confirmButtonColor: '#6bd098',
              timer: 5000,
              timerProgressBar: true
            });
          });
        });
      } catch (error) {
        this.$logger.error("Error generando Excel:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message || "Ha ocurrido un error durante la generación del archivo Excel",
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async createOnlineSalesRecordsExportData(filters) {
      const Parameters = filters || {};
      let keepFetching = true;
      let page = 0;
      let data = [];
      let currentResponse;
      let error;
      this.$swal.fire({
        title: "Descargando registros...",
        text: `Registros descargados: ${data.length}`,
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      do {
        try {
          // Construir parámetros limpios para exportación
          const cleanParameters = this.buildValidParameters(Parameters, page);
          
          this.$logger.log(`📊 Exportación página ${page}: Enviando parámetros:`, cleanParameters);
          
          currentResponse = await this.$CentralGymOPS_API.post(
            "",
            {
              Header: {
                Operacion: "/v1/sales/get/onlinesales/reportformat"
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD")
              },
              Parameters: cleanParameters,
              Body: {}
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          );
          this.$logger.log(currentResponse);
          if (currentResponse.data && currentResponse.data.result) {
            data.push(...currentResponse.data.result);
            this.downloadedRecordsCount = data.length;
            this.$logger.log("this.downloadedRecordsCount");
            this.$logger.log(this.downloadedRecordsCount);
            page++;
            keepFetching = currentResponse.data.result.length === 100;
            this.$swal.update({
              text: `Registros descargados: ${data.length}`,
            });
            this.$swal.showLoading();
          } else {
            keepFetching = false;
          }
        } catch (error) {
          throw error;
        }
      } while (keepFetching);

      return data;
    },
    async fetchExcelTemplate(templateName) {
      const template = templateName;
      try {
        const response = await this.$XLSXTemplateDownload.post(
          "",
          {
            template: template,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
            },
            responseType: "arraybuffer",
          }
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async fetchCatalogs() {
      let response;
      try {
        // Para catálogos, no necesitamos filtros, solo parámetros básicos
        const cleanParameters = this.buildValidParameters({}, 0);
        
        this.$logger.log('📂 Cargando catálogos: Enviando parámetros:', cleanParameters);
        
        response = await this.$CentralGymOPS_API.post(
          "",
          {
            Header: {
              Operacion: "/v1/sales/get/onlinesalesviewcatalogs"
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD")
            },
            Parameters: cleanParameters,
            Body: {}
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        this.$logger.error(error);
        throw error;
      }
      // this.$logger.log(response.data.result);
      if (response.data && response.data.result) {
        this.statusDictionary = response.data.result.estadosPagoOnline;
        this.trxTypeDictionary = response.data.result.tipoVentaOnline;
      }
      return;
    },
    // Método para calcular KPIs desde los registros (para compatibilidad con sistema anterior)
    calculateKPIsFromRecords(records) {
      if (!records || records.length === 0) {
        this.totalFilteredRecords = 0;
        this.totalFilteredAmount = 0;
        this.totalPaidSales = 0;
        this.totalPendingSales = 0;
        this.totalErrorSales = 0;
        this.totalSuccessfulNotifications = 0;
        return;
      }
      
      this.totalFilteredRecords = records.length;
      this.totalFilteredAmount = records.reduce((sum, sale) => {
        const amount = parseFloat(sale.itemVendido?.valorPlan) || 0;
        return sum + amount;
      }, 0);
      
      this.totalPaidSales = records.filter(sale => sale.estado === 'PAGADO').length;
      this.totalPendingSales = records.filter(sale => 
        ['PENDIENTE', 'EN CURSO'].includes(sale.estado)
      ).length;
      this.totalErrorSales = records.filter(sale => 
        ['ERROR', 'CANCELADO', 'RECHAZADO', 'EXPIRADO'].includes(sale.estado)
      ).length;
      
      this.totalSuccessfulNotifications = records.filter(sale => 
        sale.socio?.notificacionCreacion?.accepted || 
        sale.socio?.notificacionPagoExitoso?.accepted
      ).length;
    },
    // ========================================
    // MÉTODOS ACTIVOS (PAGINACIÓN LOCAL)
    // ========================================
    
    // Método de compatibilidad para eventos antiguos del componente hijo
    async handleSearch(
      page,
      selectedStatus,
      selectedTrxType,
      selectedBranch,
      dateFrom,
      dateTo,
      commerceOrder
    ) {
      // Convertir a formato unificado y usar paginación local
      const searchParams = {
        status: selectedStatus,
        trxType: selectedTrxType,
        branch: selectedBranch,
        dateFrom: dateFrom,
        dateTo: dateTo,
        commerceOrder: commerceOrder,
        page: 0, // Siempre empezar desde primera página en nueva búsqueda
        itemsPerPage: 20 // ACTUALIZADO: 20 registros por página
      };
      
      this.$logger.log('🔄 Evento handleSearch (compatibilidad) -> handleSearchUnified');
      await this.handleSearchUnified(searchParams);
    },
    
    // Método de compatibilidad para scroll infinito (deshabilitado con paginación local)
    async handleFetchNewPage(
      page,
      selectedStatus,
      selectedTrxType,
      selectedBranch,
      dateFrom,
      dateTo,
      commerceOrder
    ) {
      this.$logger.log('⚠️ handleFetchNewPage deshabilitado - usando paginación local');
      // El scroll infinito se reemplaza por paginación local
      // Este método se mantiene para compatibilidad pero no hace nada
      return;
    },
    
    // Método para actualizar gráficos usando TODOS los registros filtrados
    updateChartsWithAllData() {
      // Este método debe ser llamado desde el componente hijo
      // Los gráficos deben usar this.allFilteredRecords, no this.records
      this.$logger.log('📊 Actualizando gráficos con todos los datos filtrados:', this.allFilteredRecords.length, 'registros');
      
      // El componente hijo (OnLineSalesTable) debe recibir allFilteredRecords para gráficos
      // mientras que records sigue siendo solo la página actual
    },
    
    // ========================================
    // MÉTODOS ANTIGUOS (COMENTADOS PARA FUTURA REFERENCIA)
    // ========================================
    
    /*
    // MÉTODO ANTERIOR: handleSearch (comentado - consulta endpoint por página)
    async handleSearchOLD(page, selectedStatus, selectedTrxType, selectedBranch, dateFrom, dateTo, commerceOrder) {
      this.loading = true;
      this.$swal.fire({
        title: "Cargando!",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => { this.$swal.showLoading(); }
      });
      this.records = [];
      let Parameters = {};
      if (selectedStatus) Parameters.status = selectedStatus;
      if (selectedTrxType) Parameters.trxType = selectedTrxType;
      if (selectedBranch) Parameters.branch = selectedBranch;
      if (dateFrom) Parameters.dateFrom = dateFrom;
      if (dateTo) Parameters.dateTo = dateTo;
      if (typeof commerceOrder === "number") Parameters.sale = parseInt(commerceOrder);
      
      try {
        await this.fetchRecords(Parameters, page);
        await this.fetchAllFilteredRecordsForKPIs(Parameters);
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Error!",
          text: `${error.message || error}. Vuelve a intentarlo mas tarde.`,
          confirmButtonColor: "#6bd098",
        });
        return;
      } finally {
        this.loading = false;
      }
      this.$swal.close();
    },
    
    // MÉTODO ANTERIOR: fetchRecords (comentado - agrega registros para scroll infinito)
    async fetchRecords(filters, page) {
      const Parameters = filters || {};
      let response;
      try {
        // Construir parámetros limpios
        const cleanParameters = this.buildValidParameters(Parameters, page);
        
        this.$logger.log(`📄 fetchRecords página ${page}: Enviando parámetros:`, cleanParameters);
        
        response = await this.$CentralGymOPS_API.post("", {
          Header: {
            Operacion: "/v1/sales/get/onlinesales/pag"
          },
          Auth: {
            Token: sessionStorage.getItem("jCxbraoQeD")
          },
          Parameters: cleanParameters,
          Body: {}
        }, {
          headers: {
            "Content-Type": "application/json"
          }
        });
      } catch (error) {
        throw error;
      }
      
      if (response.data && response.data.result) {
        this.records.push(...response.data.result);
        if (response.data.result.length !== 20) {
          this.$refs.salesTable.stopFetching();
        }
      }
      return;
    }
    */
    // ========================================
    // MÉTODO NUEVO: BÚSQUEDA UNIFICADA CON PAGINACIÓN LOCAL
    // ========================================
    async handleSearchUnified(searchParams) {
      try {
        this.loading = true;
        
        // Si es cambio de página local o ordenamiento local, no consultar endpoint
        if (searchParams.isLocalPageChange) {
          if (searchParams.isSortingChange) {
            this.$logger.log('🔄 Cambio de ordenamiento local:', {
              campo: searchParams.sortField,
              direccion: searchParams.sortDirection,
              pagina: searchParams.page + 1,
              datosOrdenados: searchParams.sortedData ? searchParams.sortedData.length : 0
            });
            
            // ✅ CORREGIDO: Actualizar allFilteredRecords con los datos ordenados del componente hijo
            if (searchParams.sortedData) {
              this.allFilteredRecords = searchParams.sortedData;
              this.$logger.log('📊 allFilteredRecords actualizado con datos ordenados:', this.allFilteredRecords.length);
            }
            
            // Para ordenamiento, resetear a primera página con los datos ya ordenados
            this.updateLocalPagination(1, searchParams.itemsPerPage);
          } else {
            this.$logger.log('🔄 Cambio de página local:', searchParams.page + 1);
            this.updateLocalPagination(searchParams.page + 1, searchParams.itemsPerPage);
          }
          this.loading = false;
          return;
        }
        
        // NUEVO: Validar rango de fechas antes de la búsqueda
        if (searchParams.dateFrom && searchParams.dateTo) {
          const validation = this.validateDateRange(searchParams.dateFrom, searchParams.dateTo);
          if (!validation.valid) {
            this.loading = false;
            this.$swal.fire({
              icon: "warning",
              title: "Rango de fechas no válido",
              text: validation.message,
              confirmButtonColor: "#6bd098",
            });
            return;
          }
        }
        
        // Nueva búsqueda - limpiar datos y obtener todos los registros filtrados
        this.$logger.log('🔍 Nueva búsqueda - obteniendo todos los registros filtrados...');
        this.records = [];
        this.allFilteredRecords = [];
        
        // Preparar parámetros para la API (usando el formato original)
        let Parameters = {};
        
        this.$logger.log('🔍 searchParams recibidos:', searchParams);
        
        // Filtros básicos (manteniendo el formato original)
        if (searchParams.status) {
          Parameters.status = searchParams.status;
          this.$logger.log('✅ Agregando filtro status:', searchParams.status);
        }
        if (searchParams.trxType) {
          Parameters.trxType = searchParams.trxType;
          this.$logger.log('✅ Agregando filtro trxType:', searchParams.trxType);
        }
        if (searchParams.branch) {
          Parameters.branch = searchParams.branch;
          this.$logger.log('✅ Agregando filtro branch:', searchParams.branch);
        }
        if (searchParams.dateFrom) {
          Parameters.dateFrom = searchParams.dateFrom;
          this.$logger.log('✅ Agregando filtro dateFrom:', searchParams.dateFrom);
        }
        if (searchParams.dateTo) {
          Parameters.dateTo = searchParams.dateTo;
          this.$logger.log('✅ Agregando filtro dateTo:', searchParams.dateTo);
        }
        if (typeof searchParams.commerceOrder === "number") {
          Parameters.sale = parseInt(searchParams.commerceOrder);
          this.$logger.log('✅ Agregando filtro sale (commerceOrder):', Parameters.sale);
        }
        
        this.$logger.log('🔍 Parámetros de búsqueda construidos:', Parameters);
        this.$logger.log('🔍 Tipo de Parameters:', typeof Parameters);
        this.$logger.log('🔍 JSON de Parameters:', JSON.stringify(Parameters));
        
        // Obtener TODOS los registros filtrados de una vez
        await this.fetchAllFilteredRecordsForSearch(Parameters);
        
        // Configurar paginación local
        this.setupLocalPagination(searchParams.itemsPerPage || 20); // ACTUALIZADO: 20 registros por página
        
        // Mostrar primera página
        this.updateLocalPagination(1, this.localPagination.itemsPerPage);
        
        this.$logger.log('📊 Búsqueda completada:', {
          totalRegistrosFiltrados: this.allFilteredRecords.length,
          paginaActual: this.localPagination.currentPage,
          totalPaginas: this.localPagination.totalPages,
          registrosEnPagina: this.records.length
        });
        
      } catch (error) {
        this.$logger.error('Error en búsqueda unificada:', error);
        this.$swal.fire({
          icon: "error",
          title: "Error en la búsqueda",
          text: `${error.message || error}. Vuelve a intentarlo más tarde.`,
          confirmButtonColor: "#6bd098",
        });
      } finally {
        this.loading = false;
      }
    },
    
    // ========================================
    // MÉTODO AUXILIAR: LIMPIAR Y VALIDAR PARÁMETROS
    // ========================================
    buildValidParameters(filters, page = 0) {
      // Crear objeto base con página
      const cleanParameters = {
        page: page
      };
      
      // Agregar filtros solo si tienen valores válidos
      if (filters && typeof filters === 'object') {
        Object.keys(filters).forEach(key => {
          const value = filters[key];
          // Solo agregar valores que no sean null, undefined o string vacío
          if (value !== null && value !== undefined && value !== '') {
            // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY para la API
            if ((key === 'dateFrom' || key === 'dateTo') && this.isYYYYMMDDFormat(value)) {
              cleanParameters[key] = this.convertDateToAPI(value);
              this.$logger.log(`🗓️ Fecha convertida - ${key}: ${value} → ${cleanParameters[key]}`);
            } else {
              cleanParameters[key] = value;
            }
          }
        });
      }
      
      this.$logger.log('🔧 Parámetros de entrada:', filters);
      this.$logger.log('🔧 Parámetros limpiados:', cleanParameters);
      this.$logger.log('🔧 Tipo de Parameters:', typeof cleanParameters);
      this.$logger.log('🔧 JSON de Parameters:', JSON.stringify(cleanParameters));
      
      return cleanParameters;
    },
    
    // ========================================
    // MÉTODOS AUXILIARES PARA CONVERSIÓN DE FECHAS
    // ========================================
    
    // Verificar si una fecha está en formato YYYY-MM-DD
    isYYYYMMDDFormat(dateString) {
      if (!dateString || typeof dateString !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}$/.test(dateString);
    },
    
    // Convertir fecha de YYYY-MM-DD a DD-MM-YYYY para la API
    convertDateToAPI(dateString) {
      if (!this.isYYYYMMDDFormat(dateString)) {
        // Si ya está en formato DD-MM-YYYY o otro formato, devolverla tal como está
        return dateString;
      }
      
      try {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
      } catch (error) {
        this.$logger.warn('⚠️ Error convirtiendo fecha:', dateString, error);
        return dateString; // Devolver original si hay error
      }
    },
    
    // ========================================
    // MÉTODO NUEVO: OBTENER TODOS LOS REGISTROS FILTRADOS PARA BÚSQUEDA
    // ========================================
    async fetchAllFilteredRecordsForSearch(filters) {
      try {
        this.$logger.log('📊 Obteniendo todos los registros filtrados...');
        this.$logger.log('📊 Filtros recibidos:', filters);
        
        const allRecords = [];
        let page = 0;
        let keepFetching = true;
        
        // Mostrar progreso
        this.$swal.fire({
          title: "Cargando datos...",
          text: `Registros obtenidos: ${allRecords.length}`,
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        
        do {
          try {
            // Construir parámetros limpios
            const cleanParameters = this.buildValidParameters(filters, page);
            
            this.$logger.log(`📊 Página ${page}: Enviando parámetros:`, cleanParameters);
            
            // Construir el body completo para logging
            const requestBody = {
              Header: {
                Operacion: "/v1/sales/get/onlinesales/pag"
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD")
              },
              Parameters: cleanParameters,
              Body: {}
            };
            
            this.$logger.log('🌐 Request Body completo:', JSON.stringify(requestBody, null, 2));
            
            const response = await this.$CentralGymOPS_API.post("", requestBody, {
              headers: {
                "Content-Type": "application/json"
              }
            });
            
            this.$logger.log(`📊 Respuesta página ${page}:`, {
              status: response.status,
              statusText: response.statusText,
              hasData: !!response.data,
              hasResult: !!(response.data && response.data.result),
              resultLength: response.data && response.data.result ? response.data.result.length : 0
            });
            
            if (response.data && response.data.result && response.data.result.length > 0) {
              allRecords.push(...response.data.result);
              page++;
              keepFetching = response.data.result.length === 20; // Continuar si página completa
              
              this.$logger.log(`📊 Página ${page-1} procesada: ${response.data.result.length} registros. Total acumulado: ${allRecords.length}`);
              
              // Actualizar progreso
              this.$swal.update({
                text: `Registros obtenidos: ${allRecords.length}`,
              });
            } else {
              this.$logger.log(`📊 Página ${page}: Sin más registros. Terminando búsqueda.`);
              keepFetching = false;
            }
          } catch (pageError) {
            this.$logger.error(`❌ Error en página ${page}:`, pageError);
            this.$logger.error('❌ Request que falló:', JSON.stringify({
              url: 'CentralGymOPS_API',
              method: 'POST',
              body: {
                Header: { Operacion: "/v1/sales/get/onlinesales/pag" },
                Auth: { Token: sessionStorage.getItem("jCxbraoQeD") ? "***" : "NO_TOKEN" },
                Parameters: this.buildValidParameters(filters, page),
                Body: {}
              }
            }, null, 2));
            
            if (pageError.response) {
              this.$logger.error('❌ Response Error:', {
                status: pageError.response.status,
                statusText: pageError.response.statusText,
                data: pageError.response.data
              });
            }
            
            // Propagar el error para que lo maneje el catch principal
            throw pageError;
          }
        } while (keepFetching);
        
        // Almacenar todos los registros filtrados
        this.allFilteredRecords = allRecords;
        
        // NUEVO: Guardar copia de datos originales para filtros avanzados
        this.originalFilteredRecords = [...allRecords];
        
        // Calcular KPIs UNA SOLA VEZ con todos los datos
        this.calculateKPIsFromRecords(allRecords);
        this.totalRecords = allRecords.length;
        
        this.$swal.close();
        
        this.$logger.log('📊 Todos los registros obtenidos:', {
          totalRegistros: allRecords.length,
          kpisCalculados: {
            totalAmount: this.totalFilteredAmount,
            paidSales: this.totalPaidSales,
            pendingSales: this.totalPendingSales
          }
        });
        
      } catch (error) {
        this.$swal.close();
        this.$logger.error('Error obteniendo todos los registros:', error);
        throw error;
      }
    },
    
    // ========================================
    // MÉTODO NUEVO: CARGA INICIAL OPTIMIZADA (SOLO PRIMERA PÁGINA)
    // ========================================
    async fetchFirstPageOnly() {
      try {
        this.$logger.log('⚡ Carga inicial optimizada: Solo primera página...');
        
        // Obtener solo la primera página (sin filtros específicos)
        const cleanParameters = this.buildValidParameters({}, 0); // Sin filtros, solo página 0
        
        this.$logger.log('⚡ Carga inicial: Enviando parámetros:', cleanParameters);
        
        const response = await this.$CentralGymOPS_API.post(
          "",
          {
            Header: {
              Operacion: "/v1/sales/get/onlinesales/pag"
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD")
            },
            Parameters: cleanParameters,
            Body: {}
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        
        if (response.data && response.data.result && response.data.result.length > 0) {
          // Almacenar primera página
          this.records = response.data.result;
          this.allFilteredRecords = [...response.data.result];
          this.originalFilteredRecords = [...response.data.result];
          
          // Calcular KPIs básicos solo con primera página (temporal)
          this.calculateKPIsFromRecords(response.data.result);
          this.totalRecords = response.data.result.length;
          
          // Configurar paginación local básica
          this.setupLocalPagination(20); // ACTUALIZADO: 20 registros por página
          this.updateLocalPagination(1, 20); // ACTUALIZADO: 20 registros por página
          
          this.$logger.log('⚡ Carga inicial completada:', {
            registrosPrimeraPagina: response.data.result.length,
            mensaje: 'Use filtros para obtener más datos'
          });
        } else {
          // Sin datos en primera página
          this.records = [];
          this.allFilteredRecords = [];
          this.originalFilteredRecords = [];
          this.calculateKPIsFromRecords([]);
          this.totalRecords = 0;
        }
        
      } catch (error) {
        this.$logger.error('Error en carga inicial:', error);
        throw error;
      }
    },
    
    // ========================================
    // MÉTODOS DE PAGINACIÓN LOCAL
    // ========================================
    setupLocalPagination(itemsPerPage = 20) { // ACTUALIZADO: 20 registros por página por defecto
      this.localPagination.itemsPerPage = itemsPerPage;
      this.localPagination.totalPages = Math.ceil(this.allFilteredRecords.length / itemsPerPage);
      this.localPagination.currentPage = 1;
      
      this.$logger.log('📄 Paginación local configurada:', {
        totalRegistros: this.allFilteredRecords.length,
        itemsPorPagina: itemsPerPage,
        totalPaginas: this.localPagination.totalPages
      });
    },
    
    updateLocalPagination(page, itemsPerPage) {
      // Actualizar configuración si cambia items per page
      if (itemsPerPage && itemsPerPage !== this.localPagination.itemsPerPage) {
        this.localPagination.itemsPerPage = itemsPerPage;
        this.localPagination.totalPages = Math.ceil(this.allFilteredRecords.length / itemsPerPage);
      }
      
      // Validar página
      if (page < 1) page = 1;
      if (page > this.localPagination.totalPages) page = this.localPagination.totalPages;
      
      this.localPagination.currentPage = page;
      
      // Calcular slice de datos para la página actual
      const startIndex = (page - 1) * this.localPagination.itemsPerPage;
      const endIndex = startIndex + this.localPagination.itemsPerPage;
      
      // Actualizar records (datos mostrados en tabla) CON SLICE LOCAL
      this.records = this.allFilteredRecords.slice(startIndex, endIndex);
      
      // Actualizar totalRecords para que la paginación funcione correctamente
      this.totalRecords = this.allFilteredRecords.length;
      
      this.$logger.log('📄 Página actualizada:', {
        paginaActual: page,
        registrosMostrados: this.records.length,
        rangoIndices: `${startIndex}-${endIndex-1}`,
        totalRegistros: this.allFilteredRecords.length
      });
    },
    
    // ========================================
    // MÉTODOS DE FILTRADO AVANZADO LOCAL
    // ========================================
    applyAdvancedFiltersLocally(advancedFilters) {
      // Filtrar allFilteredRecords según filtros avanzados
      // Esto permite filtrar sobre los datos ya cargados sin consultar el endpoint
      
      if (!this.originalFilteredRecords || this.originalFilteredRecords.length === 0) {
        this.$logger.log('⚠️ No hay datos originales para filtrar localmente');
        return;
      }
      
      this.$logger.log('🔧 Aplicando filtros avanzados localmente:', advancedFilters);
      
      // Usar los datos originales como base (sin filtros previos)
      let filteredData = this.applyAdvancedFiltersToData(this.originalFilteredRecords, advancedFilters);
      
      this.$logger.log('📊 Filtrado avanzado completado:', {
        registrosOriginales: this.originalFilteredRecords.length,
        registrosFiltrados: filteredData.length,
        filtrosAplicados: Object.keys(advancedFilters).filter(key => advancedFilters[key])
      });
      
      // Actualizar datos y recalcular todo
      this.updateDataWithLocalFilters(filteredData);
    },
    
    updateDataWithLocalFilters(filteredData) {
      // Actualizar records para mostrar datos filtrados
      this.allFilteredRecords = filteredData;
      
      // Recalcular KPIs con datos filtrados
      this.calculateKPIsFromRecords(filteredData);
      this.totalRecords = filteredData.length;
      
      // Reconfigurar paginación
      this.setupLocalPagination(this.localPagination.itemsPerPage);
      this.updateLocalPagination(1, this.localPagination.itemsPerPage);
      
      // Los gráficos se actualizarán automáticamente por el watcher de allFilteredRecords
    },
    
    clearAdvancedFilters() {
      // Restaurar todos los datos originales (sin filtros avanzados)
      // Esto requiere mantener una copia de los datos originales de la consulta básica
      if (this.originalFilteredRecords && this.originalFilteredRecords.length > 0) {
        this.$logger.log('🔄 Limpiando filtros avanzados, restaurando datos originales');
        this.updateDataWithLocalFilters(this.originalFilteredRecords);
      }
    },
    
    // ========================================
    // MÉTODOS DE FILTROS DE FECHA LOCALES
    // ========================================
    applyLocalDateFilterOnData(dateFilterParams) {
      this.$logger.log('📅 Aplicando filtro de fecha local en Dashboard:', dateFilterParams);
      
      if (!this.originalFilteredRecords || this.originalFilteredRecords.length === 0) {
        this.$logger.warn('⚠️ No hay datos originales para filtrar por fecha');
        return;
      }
      
      let filteredByDate = [...this.originalFilteredRecords];
      
      // Aplicar filtro de fecha si se especifica
      if (dateFilterParams.dateFrom && dateFilterParams.dateTo && dateFilterParams.period !== 'clear') {
        filteredByDate = this.filterRecordsByDateRange(
          filteredByDate, 
          dateFilterParams.dateFrom, 
          dateFilterParams.dateTo
        );
        
        this.$logger.log(`📅 Filtrado por ${dateFilterParams.period}:`, {
          registrosOriginales: this.originalFilteredRecords.length,
          registrosFiltrados: filteredByDate.length,
          desde: dateFilterParams.dateFrom,
          hasta: dateFilterParams.dateTo
        });
      } else if (dateFilterParams.period === 'clear') {
        this.$logger.log('🗓️ Limpiando filtro de fecha, usando todos los datos originales');
        // No aplicar filtro de fecha, usar todos los datos originales
      }
      
      // Aplicar filtros avanzados sobre los datos filtrados por fecha
      if (dateFilterParams.advancedFilters) {
        const hasAdvancedFilters = Object.values(dateFilterParams.advancedFilters).some(value => 
          value && value.toString().trim() !== ''
        );
        
        if (hasAdvancedFilters) {
          this.$logger.log('🔧 Aplicando filtros avanzados después del filtro de fecha');
          filteredByDate = this.applyAdvancedFiltersToData(filteredByDate, dateFilterParams.advancedFilters);
        }
      }
      
      // Actualizar datos y recalcular todo
      this.updateDataWithLocalFilters(filteredByDate);
    },
    
    filterRecordsByDateRange(records, dateFrom, dateTo) {
      const fromDate = new Date(dateFrom);
      const toDate = new Date(dateTo);
      // Ajustar la fecha final al final del día
      toDate.setHours(23, 59, 59, 999);
      
      return records.filter(record => {
        const recordDate = new Date(record.fechaCreacion);
        return recordDate >= fromDate && recordDate <= toDate;
      });
    },
    
    applyAdvancedFiltersToData(records, advancedFilters) {
      let filteredData = [...records];
      
      // Filtro por texto (busca en socio nombre, email, responsable)
      if (advancedFilters.searchText && advancedFilters.searchText.trim()) {
        const searchTerm = advancedFilters.searchText.toLowerCase().trim();
        filteredData = filteredData.filter(record => {
          const socioNombre = (record.socio?.nombre || '').toLowerCase();
          const socioEmail = (record.socio?.email || '').toLowerCase();
          const responsable = (record.responsable || '').toLowerCase();
          
          return socioNombre.includes(searchTerm) || 
                 socioEmail.includes(searchTerm) || 
                 responsable.includes(searchTerm);
        });
      }
      
      // Filtro por plataforma
      if (advancedFilters.platform && advancedFilters.platform.trim()) {
        filteredData = filteredData.filter(record => 
          record.plataforma === advancedFilters.platform
        );
      }
      
      // Filtro por rango de monto desde
      if (advancedFilters.amountFrom && !isNaN(parseFloat(advancedFilters.amountFrom))) {
        const minAmount = parseFloat(advancedFilters.amountFrom);
        filteredData = filteredData.filter(record => {
          const amount = parseFloat(record.itemVendido?.valorPlan) || 0;
          return amount >= minAmount;
        });
      }
      
      // Filtro por rango de monto hasta
      if (advancedFilters.amountTo && !isNaN(parseFloat(advancedFilters.amountTo))) {
        const maxAmount = parseFloat(advancedFilters.amountTo);
        filteredData = filteredData.filter(record => {
          const amount = parseFloat(record.itemVendido?.valorPlan) || 0;
          return amount <= maxAmount;
        });
      }
      
      // Filtro por estado de notificaciones
      if (advancedFilters.notificationStatus && advancedFilters.notificationStatus.trim()) {
        filteredData = filteredData.filter(record => {
          const hasSuccessfulNotification = record.socio?.notificacionCreacion?.accepted || 
                                          record.socio?.notificacionPagoExitoso?.accepted;
          const hasFailedNotification = record.socio?.notificacionCreacion === false || 
                                       record.socio?.notificacionPagoExitoso === false;
          
          switch (advancedFilters.notificationStatus) {
            case 'success':
              return hasSuccessfulNotification;
            case 'error':
              return hasFailedNotification;
            case 'pending':
              return !hasSuccessfulNotification && !hasFailedNotification;
            default:
              return true;
          }
        });
      }
      
      return filteredData;
    },
    
    // ========================================
    // MÉTODOS DE FECHAS Y VALIDACIONES
    // ========================================
    getDefaultDateRange() {
      const today = new Date();
      const threeMonthsAgo = new Date(today);
      threeMonthsAgo.setMonth(today.getMonth() - 3);
      
      return {
        dateFrom: threeMonthsAgo.toISOString().split('T')[0],  // YYYY-MM-DD
        dateTo: today.toISOString().split('T')[0]              // YYYY-MM-DD
      };
    },
    
    // ========================================
    // MÉTODOS PARA BÚSQUEDA AUTOMÁTICA DEL MES EN CURSO
    // ========================================
    
    // Obtener el primer día del mes actual en formato DD-MM-YYYY (para API OnLineSales)
    getFirstDayOfCurrentMonth() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      
      const day = firstDay.getDate().toString().padStart(2, '0');
      const month = (firstDay.getMonth() + 1).toString().padStart(2, '0');
      const year = firstDay.getFullYear();
      
      return `${day}-${month}-${year}`;
    },
    
    // Obtener el último día del mes actual en formato DD-MM-YYYY (para API OnLineSales)
    getLastDayOfCurrentMonth() {
      const today = new Date();
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      
      const day = lastDay.getDate().toString().padStart(2, '0');
      const month = (lastDay.getMonth() + 1).toString().padStart(2, '0');
      const year = lastDay.getFullYear();
      
      return `${day}-${month}-${year}`;
    },
    
    // Realizar búsqueda automática del mes en curso
    async performCurrentMonthSearch() {
      try {
        this.$logger.log('📅 Iniciando búsqueda automática del mes en curso...');
        
        const currentMonthFilters = {
          dateFrom: this.getFirstDayOfCurrentMonth(),
          dateTo: this.getLastDayOfCurrentMonth(),
          status: '', // Todos los estados
          trxType: '', // Todos los tipos
          branch: '', // Todas las sucursales
          commerceOrder: null // Sin búsqueda por ID específico
        };
        
        this.$logger.log('📊 Filtros del mes en curso configurados:', {
          fechaDesde: currentMonthFilters.dateFrom,
          fechaHasta: currentMonthFilters.dateTo,
          mes: new Date().toLocaleString('es-CL', { month: 'long', year: 'numeric' })
        });
        
        // Realizar búsqueda del mes en curso
        await this.handleSearchUnified(currentMonthFilters);
        
        this.$logger.log('✅ Búsqueda automática del mes en curso completada:', {
          registrosEncontrados: this.allFilteredRecords ? this.allFilteredRecords.length : 0,
          montoTotal: this.totalFilteredAmount,
          pagosExitosos: this.totalPaidSales,
          transaccionesPendientes: this.totalPendingSales
        });
        
        return true;
      } catch (error) {
        this.$logger.error('❌ Error en búsqueda automática del mes en curso:', error);
        throw error;
      }
    },
    
    validateDateRange(dateFrom, dateTo) {
      if (!dateFrom || !dateTo) return { valid: true }; // Sin fechas = válido
      
      const fromDate = new Date(dateFrom);
      const toDate = new Date(dateTo);
      const diffTime = Math.abs(toDate - fromDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const maxDays = 365; // 1 año máximo
      
      if (diffDays > maxDays) {
        return {
          valid: false,
          message: `El rango de fechas no puede ser mayor a 1 año. Rango actual: ${diffDays} días.`
        };
      }
      
      return { valid: true };
    },
  },
  beforeMount() {
    this.$swal.fire({
      title: "Cargando!",
      text: "Espera un momento...",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });
    this.branches = [...JSON.parse(sessionStorage.getItem("xxxwypt5ip"))];
    try {
      Promise.all([this.fetchCatalogs()]).then(() => {
        // NUEVO: Búsqueda automática del mes en curso al cargar el componente
        this.$logger.log('📅 Inicializando transacciones on-line con búsqueda automática del mes en curso...');
        
        return this.performCurrentMonthSearch().then(() => {
          this.$swal.close();
          
          const mesActual = new Date().toLocaleString('es-CL', { month: 'long', year: 'numeric' });
          
          this.$logger.log('✅ Inicialización de transacciones del mes en curso completada exitosamente:', {
            transaccionesDelMes: this.allFilteredRecords ? this.allFilteredRecords.length : 0,
            mes: mesActual,
            montoTotal: this.totalFilteredAmount,
            mensaje: '✅ Mostrando transacciones del mes actual automáticamente'
          });
          
          // Modal informativo deshabilitado por solicitud del usuario
          // Los datos del mes actual se cargan automáticamente sin mostrar resumen
          
        }).catch((error) => {
          this.$logger.error('❌ Error en búsqueda automática del mes en curso:', error);
          this.$swal.fire({
            icon: 'error',
            title: '❌ Error en Búsqueda Automática',
            html: `
              <div class="text-left">
                <p><strong>No se pudieron cargar las transacciones del mes en curso</strong></p>
                <p class="text-muted">${error.message || 'Error de conexión'}</p>
                <hr>
                <p><strong>💡 Opciones disponibles:</strong></p>
                <ul>
                  <li>🔄 Recargue la página para intentar nuevamente</li>
                  <li>🔍 Use los filtros para realizar búsquedas específicas</li>
                  <li>📅 Configure manualmente el rango de fechas</li>
                  <li>📞 Contacte a soporte si el problema persiste</li>
                </ul>
              </div>
            `,
            confirmButtonColor: '#6bd098',
            confirmButtonText: 'Entendido'
          });
        });
      });
    } catch (error) {
      this.$swal
        .fire({
          title: "Error",
          text: `${
            error.message || "Ha ocurrido un error inesperado"
          } , vuelve a intentarlo mas tarde, si el problema persiste toma contacto con soporte.`,
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        })
        .then(() => {
          this.$router.push("/");
        });
    }
  },
};

/*
  RESUMEN EJECUTIVO - OnLineSales v2.3 CARGA AUTOMÁTICA MES EN CURSO + PAGINACIÓN 20 REGISTROS
  =============================================================================================
  
  ✅ FUNCIONALIDADES OPERATIVAS:
  - 📅 CARGA AUTOMÁTICA DEL MES EN CURSO: Carga todas las transacciones del mes actual al inicializar
  - 📄 PAGINACIÓN 20 REGISTROS: Navegación local con 20 registros por página
  - 💾 Filtros guardados LOCALES: Trabajan sobre datos ya cargados (sin consultas al servidor)
  - 🔍 Validación de rangos: Máximo 1 año de diferencia entre fechas
  - 🎯 Filtros básicos: Estado, Tipo TRX, Sucursal, Fechas, ID Comercio
  - 🔧 Filtros avanzados LOCALES: Texto, plataforma, rangos monto, estado notif.
  - 📄 Paginación LOCAL: Navega entre páginas SIN consultar endpoint
  - 📊 KPIs DINÁMICOS: Se recalculan con filtros aplicados localmente
  - 📈 Gráficos DINÁMICOS: Se actualizan con filtros aplicados localmente
  - 📋 Exportación: Excel con datos filtrados + PDF de KPIs con cabecera
  - ✅ Selección múltiple: Acciones en lote para reenvíos y cancelaciones
  - 💿 Filtros guardados: Persistencia local con aplicación sobre datos en memoria
  
  🆕 NUEVAS FUNCIONALIDADES v2.3:
  - 📅 BÚSQUEDA AUTOMÁTICA DEL MES: Al cargar el componente obtiene TODAS las transacciones del mes actual
  - 📄 PAGINACIÓN 20 REGISTROS: Cambio de 50 a 20 registros por página para mejor UX
  - 🗓️ FECHAS AUTOMÁTICAS: Primer día del mes → Último día del mes en filtros iniciales
  - 📊 PDF CON CABECERA: Exportación de KPIs con título y fecha de generación
  - 🎯 UX MEJORADA: Usuario obtiene datos completos del mes en la primera interacción
  - 🔄 CONVERSIÓN AUTOMÁTICA DE FECHAS: Sistema inteligente que convierte YYYY-MM-DD → DD-MM-YYYY para API
  
  ⚡ MEJORAS v2.3:
  - 📅 CARGA INTELIGENTE: Todas las transacciones del mes vs solo primera página
  - 📄 PAGINACIÓN OPTIMIZADA: 20 registros por página para mejor navegación
  - 🔧 NAVEGACIÓN EN MEMORIA: Cambio de página sin consultas adicionales al servidor
  - 📊 KPIs COMPLETOS: Calculados con TODOS los datos del mes, no solo una página
  - 🎯 UX INMEDIATA: Datos completos del mes disponibles instantáneamente
  
  🔄 PREPARADO PARA BACKEND:
  - 🔢 Ordenamiento dinámico: Por cualquier columna (asc/desc) 
  - 📊 KPIs optimizados: Calculados en backend sin cargar todos los registros
  - 🎯 Filtros avanzados en servidor: Para evitar descargas masivas de datos
  
  📊 FLUJO OPTIMIZADO DE DATOS v2.3:
  1. 📅 Inicialización INTELIGENTE: Carga automática de transacciones del mes actual
  2. 🔍 Búsqueda por filtros: Obtiene TODOS los registros filtrados cuando el usuario busca
  3. 💾 Almacenamiento: originalFilteredRecords (backup) + allFilteredRecords (actual)
  4. 🔧 Filtros avanzados: Filtrado local sobre allFilteredRecords
  5. 💿 Filtros guardados: Aplicación LOCAL instantánea sobre datos cargados
  6. 📊 KPIs: Se recalculan dinámicamente con cualquier filtro
  7. 📄 Paginación: Local usando slice del array filtrado (20 registros por página)
  8. 📈 Gráficos: Se actualizan dinámicamente con datos filtrados
  
  🗓️ MANEJO INTELIGENTE DE FECHAS v2.3:
  - ✅ FRONTEND: Inputs de fecha usan formato YYYY-MM-DD (estándar HTML5)
  - ✅ API: Acepta fechas en formato DD-MM-YYYY según especificación
  - 🔄 CONVERSIÓN AUTOMÁTICA: buildValidParameters() detecta y convierte automáticamente:
    * getFirstDayOfCurrentMonth() → "01-12-2024" (DD-MM-YYYY directo)
    * getLastDayOfCurrentMonth() → "31-12-2024" (DD-MM-YYYY directo)
    * Filtros frontend "2024-12-01" → "01-12-2024" (conversión automática)
  - 📊 LOG DE CONVERSIÓN: Registra todas las conversiones para debugging
  - 🛡️ VALIDACIÓN: Detecta formato antes de convertir, mantiene compatibilidad
  
  🎯 COMPORTAMIENTO FILTROS GUARDADOS v2.2:
  - ✅ Aplicación LOCAL: No consulta servidor, trabaja sobre datos en memoria
  - ⚡ Instantáneo: Aplicación inmediata sin esperas
  - 🔧 Completo: Incluye todos los filtros + ordenamiento
  - 💾 Persistente: Guardado en localStorage del navegador
  - 🔄 Inteligente: Valida que existan datos antes de aplicar
  - 📊 Reactivo: KPIs y gráficos se actualizan automáticamente
  
  🚀 OPTIMIZACIONES FUTURAS OPCIONALES:
  1. Implementar soporte para filtros avanzados en "/v1/sales/get/onlinesales/pag"
     (para evitar descargar todos los datos y filtrar localmente)
  2. Implementar ordenamiento dinámico en servidor
  3. Implementar endpoint optimizado que retorne KPIs sin cargar todos los registros
  4. Implementar caché de consultas frecuentes
  5. Implementar filtros guardados sincronizados entre dispositivos (base de datos)
*/
</script>

<style></style>
